(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hokema-us-popup"] && !Shopify.designMode) return;
  try {
    (() => {
  const dialog = document.getElementById('hokema-us-popup');
  if (!dialog || typeof dialog.showModal !== 'function' || dialog.dataset.initialized) return;
  dialog.dataset.initialized = 'true';

  const key = 'hokema-us-shop-choice-v1';
  const lifetime = 30 * 24 * 60 * 60 * 1000;
  const preview = window.Shopify?.theme?.role === 'unpublished'
    && new URLSearchParams(window.location.search).get('hokema_us_popup') === 'preview';
  let previousFocus;
  let previousOverflow;

  function hasChoice() {
    try {
      const value = JSON.parse(window.localStorage.getItem(key));
      return ['us', 'stay'].includes(value?.choice) && value.expires > Date.now();
    } catch { return false; }
  }

  function remember(choice) {
    if (preview) return;
    try {
      window.localStorage.setItem(key, JSON.stringify({ choice, expires: Date.now() + lifetime }));
    } catch { /* Browsing remains available when storage is blocked. */ }
  }

  function dismiss(choice = 'stay') {
    remember(choice);
    dialog.close();
  }

  dialog.querySelector('.hk-close').addEventListener('click', () => dismiss());
  dialog.querySelector('.hk-stay').addEventListener('click', () => dismiss());
  dialog.querySelector('.hk-action').addEventListener('click', () => dismiss('us'));
  dialog.addEventListener('cancel', event => {
    event.preventDefault();
    dismiss();
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right
      || event.clientY < bounds.top || event.clientY > bounds.bottom) dismiss();
  });
  dialog.addEventListener('close', () => {
    if (previousOverflow !== undefined) document.documentElement.style.overflow = previousOverflow;
    previousOverflow = undefined;
    if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
  });
  window.addEventListener('pagehide', () => {
    if (dialog.open) dialog.close();
  });

  function anotherDialogIsOpen() {
    return [...document.querySelectorAll('dialog[open], [aria-modal="true"], .popup--visible')]
      .some(element => element !== dialog
        && !element.closest('details:not([open]), [hidden], [aria-hidden="true"]')
        && element.getClientRects().length
        && getComputedStyle(element).visibility !== 'hidden');
  }

  function offerShop() {
    const deadline = Date.now() + 45000;
    function openWhenReady() {
      if (!dialog.isConnected || (!preview && hasChoice())) return;
      if (document.visibilityState === 'hidden' || anotherDialogIsOpen()) {
        if (Date.now() < deadline) window.setTimeout(openWhenReady, 500);
        return;
      }
      previousFocus = document.activeElement;
      previousOverflow = document.documentElement.style.overflow;
      try {
        dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        dialog.dataset.status = preview ? 'preview' : 'offered';
        dialog.querySelector('.hk-action').focus({ preventScroll: true });
      } catch {
        previousOverflow = undefined;
      }
    }
    window.setTimeout(openWhenReady, preview ? 0 : 1200);
  }

  async function detectCountry() {
    if (preview) { offerShop(); return; }
    if (window.Shopify?.designMode || hasChoice()) return;
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 5000);
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=false', {
        credentials: 'same-origin', headers: { Accept: 'application/json' }, signal: controller.signal
      });
      if (!response.ok) return;
      const result = await response.json();
      const country = result?.detected_values?.country?.handle;
      dialog.dataset.status = country === 'US' ? 'detected-us' : 'not-us';
      if (country === 'US') offerShop();
    } catch {
      dialog.dataset.status = 'unavailable';
    } finally {
      window.clearTimeout(timeout);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', detectCountry, { once: true });
  } else {
    detectCountry();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
